import styled from "styled-components";

interface ITagProps {
    backgroundColor: string;
    borderColor: string;
    isSavingsAvailable: boolean;
    bgImage?: string;
    isSavingCardsAvailable: boolean;
}
export const TagContainer = styled.div<ITagProps>(
    ({ isSavingsAvailable, backgroundColor, borderColor, theme, bgImage, isSavingCardsAvailable }) => ({
        position: "relative",
        width: "100%",
        backgroundColor: backgroundColor || "rgba(255, 225, 222, 1)",
        textAlign: isSavingsAvailable ? "start" : "center",
        padding: theme.spacing.xxSmall,
        borderRadius: isSavingsAvailable || bgImage ? theme.spacing.small : theme.spacing.xSmall,
        marginBottom: isSavingCardsAvailable || !isSavingsAvailable ? theme.spacing.xxLarge : theme.spacing.xxSmall,
        border: `1px solid ${borderColor || theme.colors[theme.colorMode].border_Tertiary}`,
        paddingTop: theme.spacing.xSmall,
        paddingLeft: isSavingsAvailable ? theme.spacing.small : theme.spacing.empty,
        display: "flex",
        justifyContent: isSavingsAvailable ? "normal" : "center",
        alignItems: "center",
        zIndex: 2,
        backgroundImage: bgImage ? `url(${bgImage})` : "none",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        overflow: "hidden",
    }),
);

export const ImageContainter = styled.div(() => ({
    width: "82%",
}));
